import React from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './App.css';
import { UserContextProvider } from "./context/UserContextProvider";
import AppRouter from "./AppRouter";



function App() {
  return (
    <div className="App">
      <UserContextProvider>
      <BrowserRouter>
          <AppRouter />
      </BrowserRouter>
      </UserContextProvider>

    </div>
  );
}

export default App;
